import React from "react";
import { Typography } from "antd-min";
import { CONSTS, fmtMsg } from "@app/util";
import { SchoolLocale } from "@app/locales/localeid";

export const VideoRetentionMsg = () => {
    return <Typography.Text>{fmtMsg({ id: SchoolLocale.VisitationVideosRetentionText })}</Typography.Text>
}
